import getCookie from '@gcloud-npm/utils.common.get-cookie';
import { COOKIES } from '@/constants/constant';

export const setCookie = (name, value, minutes) => {
  const now = new Date();
  const expiryTime = now.getTime() + minutes * 60000;
  now.setTime(expiryTime);

  const expires = `expires=${now.toUTCString()}`;
  const secure = 'secure';
  const sameSite = 'SameSite=Strict';
  const encodedData = window.btoa(JSON.stringify(value));
  document.cookie = `${name}=${encodedData}; ${expires}; path=/; ${secure}; ${sameSite}`;
};

export const getInitialUrlFromCookie = () => {
  if (typeof window !== 'undefined') {
    const cookieUrl = getCookie(COOKIES.SETH_REG_URL);
    const decodedUrl = atob(cookieUrl);
    return decodedUrl;
  }
  return '';
};

export const isWebViewFromCookie = () => {
  if (typeof window !== 'undefined') {
    const isWebView = getCookie(COOKIES.SETH_REG_WB);
    return isWebView === true || isWebView === 'true';
  }
  return false;
};

export const getFinalOperationFromCookie = () => {
  if (typeof window !== 'undefined') {
    const cookieOperation = getCookie(COOKIES.SETH_REG_OP);
    return cookieOperation;
  }
  return '';
};
